import { NormalizedDeviceHardware } from "../data/device-hardware";
import { normalizeDeviceHardware } from "./device-hardware-utils";
import { VelavuAPI } from "../dao/velavu-api";
/** The default cooldown duration for locating a device
 * @deprecated Use DEFAULT_INDICATE_TIMEOUT instead
 */
export const LOCATE_COOLDOWN_TIME = 30 * 1000;
/**
 * Determines what method a user can use to locate a device
 * @deprecated Use DeviceIndicatorType instead
 */
export var VelavuLocateMethod;
(function (VelavuLocateMethod) {
    VelavuLocateMethod[VelavuLocateMethod["LED"] = 0] = "LED";
    VelavuLocateMethod[VelavuLocateMethod["Buzzer"] = 1] = "Buzzer";
})(VelavuLocateMethod || (VelavuLocateMethod = {}));
export function resolveLocateMethod(device) {
    switch (normalizeDeviceHardware(device?.hardware)) {
        case NormalizedDeviceHardware.Argo:
            return VelavuLocateMethod.LED;
        case NormalizedDeviceHardware.Juno:
        case NormalizedDeviceHardware.Meridian:
            return VelavuLocateMethod.Buzzer;
        default:
            return null;
    }
}
/**
 * Triggers the locate method on a device
 * @param deviceID The ID of the device to locate
 * @param method The method to use to locate the device
 * @deprecated Use VelavuAPI.devices.indicateDevice instead
 */
export function deviceTriggerLocate(deviceID, method) {
    switch (method) {
        case VelavuLocateMethod.LED:
            return deviceFlashLED(deviceID);
        case VelavuLocateMethod.Buzzer:
            return devicePlaySound(deviceID);
    }
}
/**
 * Activates the buzzer on a device
 * @param deviceID The ID of the device to locate
 * @deprecated Use VelavuAPI.devices.indicateDevice instead
 */
export function devicePlaySound(deviceID) {
    return VelavuAPI.devices.modifySpecificDevice(deviceID, {
        state: {
            buzzer_on: true
        }
    });
}
/**
 * Activates the LED on a device
 * @param deviceID The ID of the device to locate
 * @deprecated Use VelavuAPI.devices.indicateDevice instead
 */
export function deviceFlashLED(deviceID) {
    return VelavuAPI.devices.modifySpecificDevice(deviceID, {
        state: {
            led_flash_on: true
        }
    });
}
//# sourceMappingURL=locate.js.map